import Ws from '@adonisjs/websocket-client';

const HOST = process.env.REACT_APP_HOST;
const WS_HOST = HOST.replace('http', 'ws');

export function connectWS(token) {
  const ws = Ws(WS_HOST, {
    path: 'reduto-ws',
    query: { token },
  });

  ws.connect();
  return ws;
}
